
import {
  defineComponent, ref, onMounted, reactive, inject,
} from 'vue';

import {
  ConfigProvider, Table,
} from 'ant-design-vue';
import zhCN from 'ant-design-vue/es/locale/zh_CN';

export default defineComponent({
  components: {
    ConfigProvider,
    Table,
  },
  props: {
    baseInfo: {
      type: Object,
      default: () => ({}),
    },
    modalType: {
      type: String,
      default: () => 'add',
      require: true,
    },
  },
  setup (props, { emit, }) {
    const itemInfo: any = inject('itemInfo');

    const tableData = ref<any>([]);

    // 列表行配置
    const columns = [
      {
        title: '操作时间',
        dataIndex: 'time',
        ellipsis: true,
        align: 'center',
      },
      {
        title: '操作内容',
        dataIndex: 'content',
        ellipsis: true,
        align: 'center',
      },
      {
        title: '操作人',
        dataIndex: 'user',
        ellipsis: true,
        align: 'center',
      },
    ];

    const getLogs = (id:string) => {
      if (props.modalType === 'add') {
        tableData.value = [];
      }

      /*
       * getAccountDataMock().then((res:any) => {
       *   const data = res.log;
       */

      /*
       *   tableData.value = data.list;
       * });
       */
    };

    onMounted(() => {
      getLogs(itemInfo.value.id);
    // initSeleted(itemInfo.value.menuIds);
    });

    return {
      zhCN,
      columns,
      tableData,
    };
  },
});
